import { merge, transform, isEqual, isObject } from 'lodash';
import { DATA_TYPE } from '@/store/modules/cards/constants';

export default {
  computed: {
    maxWidth() {
      if (this.isMobile) return '100%';

      return '970px';
    },
  },
  methods: {
    differenceBetweenTwoObject(oldFilters, newFilters) {
      const mergedFilters = merge({}, oldFilters, newFilters);

      return transform(mergedFilters, (result, value, key) => {
        if (!isEqual(value, oldFilters[key])) {
          result[key] = this.filterValue(oldFilters, value, key);
        }
        if (!isEqual(value, newFilters[key])) {
          result[key] = this.filterValue(newFilters, value, key);
        }
      });
    },
    applyFallbackToFilters(filters, dataType) {
      const sacStatusValue = dataType === DATA_TYPE.SAC ? 'Status de antendimento' : 'Status novo';
      const channelValue = dataType === DATA_TYPE.LISTENING ? 'Canais Listening' : 'Canais Proprietário';

      const FILTERS = {
        sac_status: sacStatusValue,
        names: 'Grupos',
        channels: channelValue,
        channels_listening: 'Canais Listening',
        themes: 'Temas',
        pids: 'Publicações com id',
        genders: 'Gênero',
        polarities: 'Sentimento',
        tags: 'Tags',
        favorite: 'Publicações checadas',
        dark_post: 'Tipo de Publicação',
        sac_last_status: 'Status antigo',
        sac_replier: 'Respondentes',
        sac_type: 'Interação',
        pages: 'Páginas',
        uids: 'Autores',
        contracts: 'Contrato',
        bots: 'Bot',
        category: 'Categoria',
      };

      const FILTERS_NEGATION = [
        'tags',
        'names',
        'themes',
        'uids',
      ];

      if (!dataType) {
        return filters.map((filter) => FILTERS[filter] || filter);
      }

      return filters.map((filter) => {
        if (this.card.props.filter &&
          FILTERS_NEGATION.includes(filter) &&
          this.card.props.filter[filter]?.value.some(value => value?.indexOf('-') === 0)) {
          return `-${FILTERS[filter]}` || `-${filter}`;
        }
        return FILTERS[filter] || filter;
      });
    },
    filterValue(filter, value, key) {
      return isObject(value) && isObject(filter[key]) ? this.differenceBetweenTwoObject(value, filter[key]) : value;
    },
    dateHasChange(actualDate, toDate) {
      const diffInStartDate = actualDate.start.diff(toDate.start, 'minutes') !== 0;
      const diffInEndDate = actualDate.end.diff(toDate.end, 'minutes') !== 0;

      return diffInStartDate || diffInEndDate;
    },
    filterMessage(value) {
      return value.length === 1 ? 'selecionado' : 'selecionados';
    },
    generateObjectToNegativationFilter(value) {
      return {
        text: value,
        shouldIgnore: false,
        value,
        hasIgnoreOption: true,
      };
    },
  },
};
